import React from 'react';
import styles from './styles.module.css';
import { Icon } from 'common/icon';
import Link from 'next/link';
import { IStreamer } from 'constants/types';

interface IconButtonProps {
  icon: React.JSX.Element;
  src: string;
}

const IconButton = ({ icon, src }: IconButtonProps) => {
  return (
    <Link target="_blank" className={styles.iconWrapper} href={src}>
      {icon}
    </Link>
  );
};

interface LinksProps {
  data: IStreamer;
}

export const HeaderLinks = ({ data }: LinksProps) => {
  const links = [
    {
      icon: <Icon.Twitch />,
      src: data.twitch,
    },
    {
      icon: <Icon.Youtube color="#F30101" innerColor="white" />,
      src: data.youtube,
    },
    {
      icon: <Icon.Kick />,
      src: data.kick,
    },
    {
      icon: <Icon.Instagram />,
      src: data.instagram,
    },
    {
      icon: <Icon.Twitter />,
      src: data.twitter,
    },
  ];

  return (
    <nav className={styles.container}>
      <span className={styles.linksText}>Links</span>
      {links
        ?.filter((item) => item.src?.length)
        ?.map((link, index) => (
          <IconButton key={index} icon={link.icon} src={link.src ?? ''} />
        ))}
    </nav>
  );
};
